/**
 * @fileoverview Local-testing helper: builds a mock upload response.
 *
 * In development mode the app does not call the real upload backend, so the upload action
 * fabricates a response instead. This isolates that construction into a single pure function
 * (mirroring how the mock backend isolates dynamic responses, e.g. `paginateTicketList`), keeping
 * the dev branch of the upload action readable.
 *
 * The returned shape matches `IUploadResponse` (what `findEncryptedDocumentPath` consumes), and
 * every value is read from the same `FormData` the real request would send, so the subsequent
 * lookup resolves the just-uploaded document.
 */

import { IUploadResponse } from './findEncryptedDocumentPath';

export const buildMockUploadResponse = (formData: FormData): IUploadResponse => {
    const file = formData.get('file');
    const encryptedDocumentPath =
        file && typeof file !== 'string' ? URL.createObjectURL(file) : undefined;

    return {
        success: true,
        payload: {
            applicants: [
                {
                    applicantEventId: formData.get('applicantEventId') as string,
                    documents: [
                        {
                            categoryType: formData.get('categoryType') as string,
                            documentTypes: [
                                {
                                    documentType: formData.get('documentType') as string,
                                    uploadedFileName: formData.get('name') as string,
                                    uploadedFileSize: formData.get('size') as string,
                                    encryptedDocumentPath,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    };
};
